import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import React, { useContext, useMemo } from 'react'
import useCruiseSearchFacets from 'hooks/Cruise/useCruiseSearchFacets'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import CruiseLineMobileInput from './CruiseLineMobileInput'
import CruiseLineDesktopInput from './CruiseLineDesktopInput'

interface Props {
  onChange: (values: App.CruiseGlobalFilters) => void
  dropdownAnchorRef?: React.RefObject<HTMLElement>
}

function CruiseLineInputFilter({ onChange, dropdownAnchorRef }: Props) {
  const { cruiseLines: searchCruiseLines } = useContext(GlobalSearchStateContext)
  const [cruiseLines] = useCruiseSearchFacets({ facetTypes: ['cruise_lines'] })

  const cruiseLineNames = useMemo(() => {
    return cruiseLines
      .filter(({ value }) => searchCruiseLines?.includes(value as string))
      .map(({ name }) => name)
  }, [searchCruiseLines, cruiseLines])

  const cruiseLineLabel = useMemo(() => {
    const [firstName] = cruiseLineNames
    const more = cruiseLineNames.length > 1 ? `+${cruiseLineNames.length - 1}` : ''
    return firstName && `${firstName} ${more}`
  }, [cruiseLineNames])

  return (
    <div>
      <CSSBreakpoint max="xs">
        <CruiseLineMobileInput
          onChange={onChange}
          cruiseLineLabel={cruiseLineLabel}
        />
      </CSSBreakpoint>

      <CSSBreakpoint min="sm">
        <CruiseLineDesktopInput
          onChange={onChange}
          cruiseLineLabel={cruiseLineLabel}
          dropdownAnchorRef={dropdownAnchorRef}
        />
      </CSSBreakpoint>
    </div>
  )
}

export default CruiseLineInputFilter
